import './Home.css';

import homePageBanner from '../../assets/images/homePageBanner.png'
import message from '../../assets/images/message.svg'
import flower from '../../assets/images/flower.svg'
import barChart from '../../assets/images/barChart.svg'
import protect from '../../assets/images/protect.svg'
import brain from '../../assets/images/brain.svg'

import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { FiArrowRight } from "react-icons/fi";

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Home = () => {
  return (
    <div className="home">
      <Header />

      <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
        <h1 className="banner-title ">Meet Your AI Superagent.</h1>
        <p className="banner-description">
          Talk to your data using natural language and our Superagent will help you get insights instantly.
        </p>
        <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}><FiArrowRight size={16} /> Get Started Free</button>
      </div>
      <div className='banner-section d-flex align-items-end' style={{ height: '475px' }}>
        <div className='rectange-bg'>
          <img src={homePageBanner} alt="" />
        </div>
      </div>

      {/* <div className='banner-section d-md-none d-block'>
        <div className='position-relative d-flex justify-content-center align-items-center'>
          <div className='bannerRound'></div>
          <div className='bannerBg'></div>
        </div>
        <div className='d-flex flex-column justify-content-center gap-24 p-0 pe-4 mt-4'>
          <div>
            <h3>Say Hello to Your AI Wingman for Everyday Work</h3>
          </div>
          <div className='d-flex align-items-center gap-24'>
            <p className='font-18'>New Here? Sign Up Now!</p>
            <button className='right-round-btn' onClick={() => navigate('/signup')} > <img src={rightArrow} alt="rightArrow" /></button>
          </div>
          <div className='box'>
            <img src={star} alt="star" className='p-3' />
            <p className='font-18'>BrainyAgent is your always-on AI co-worker, ready to read your data and instantly turn it into insights, tasks, and progress.</p>
          </div>

        </div>
      </div> */}

      <div className='cards-section'>
        {/* <h3>What is BrainyAgent?</h3> */}
        <div className='d-flex gap-24 w-100 card-container'>
          <div className='card-section'>
            <h4>24/7 Workhorse</h4>
            <h5>Never takes a break. Brainyagent is always ready to analyze, summarize, and respond instantly.</h5>
          </div>
          <div className='card-section'>
            <h4>From Prompt to Progress</h4>
            <h5>Turn one small prompt into reports, charts, or tasks. No manual setup, no wasted time.</h5>
          </div>
          <div className='card-section'>
            <h4>Quick Learner</h4>
            <h5>From solo users to large organizations, Brainyagent adapts to your needs with secure, compliant infrastructure.</h5>
          </div>
        </div>
      </div>

      <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
        <h1 className="banner-title ">What makes Brainyagent powerful?</h1>
      </div>

      <div style={{ padding: '64px 200px' }}>
        {/* <h3>What is BrainyAgent?</h3> */}

        <div className='row w-100'>
          <div className='p-3 col-8'>
            <div className='card-section-with-border'>
              <h3><img src={message} alt="" /></h3>
              <h4>Chat With Your Data</h4>
              <h5>Query across databases and files as easily as sending a message. Brainyagent turns prompts into insights instantly. No SQL required.</h5>
            </div>
          </div>
          <div className='p-3 col-4'>
            <div className='card-section-with-border'>
              <h3><img src={protect} alt="" /></h3>
              <h4>Enterprise-Ready</h4>
              <h5>SOC II Type 2 compliance, SSO, and 2FA built in, so your data stays private and secure.</h5>
            </div>
          </div>
        </div>
        <div className=' row w-100'>
          <div className='p-3 col-4'>
            <div className='card-section-with-border'>
              <h3><img src={brain} alt="" /></h3>
              <h4>Advanced Reasoning</h4>
              <h5>Supports DeepSeek and other large models for smarter insights.</h5>
            </div>
          </div>
          <div className=' p-3 col-4'>
            <div className='card-section-with-border'>
              <h3><img src={barChart} alt="" /></h3>
              <h4>Smart Reports & Dashboards</h4>
              <h5>Generate charts, tables, and custom dashboards on the fly. Export results to PDF, Excel, or share with your team.</h5>
            </div>
          </div>
          <div className=' p-3 col-4'>
            <div className='card-section-with-border'>
              <h3><img src={flower} alt="" /></h3>
              <h4>Data Connections</h4>
              <h5>Connect to PostgreSQL, MySQL, MSSQL, Google Drive and more.</h5>
            </div>
          </div>
        </div>
      </div>

      <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
        <h1 className="banner-title w-75">One small prompt for automation, one giant leap for productivity!</h1>
        <p className="banner-description">
          Talk to your data using natural language and our Superagent will help you get insights instantly.
        </p>
        <div className='d-flex gap-3'>
          <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}><FiArrowRight size={16} />Start Free Today</button>
          <button className="theme-rounded-outline-btn" style={{ padding: '16px 24px' }}><FiArrowRight size={16} />See All Plans</button>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Home
